import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock } from 'lucide-react';

const Slide7GTM = () => {
    return (
        <div className="w-full h-full bg-background p-8 lg:p-16 flex flex-col justify-center items-center relative overflow-hidden">
            {/* Background Grid Texture */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
            />
            <motion.div className="text-center mb-12 relative z-10">
                <h2 className="text-4xl lg:text-6xl font-bold mb-4">Aligned with <span className="text-primary">User Outcomes</span></h2>
                <p className="text-xl text-muted-foreground">Freemium-to-Subscription Model</p>
            </motion.div>

            <div className="flex flex-col lg:flex-row gap-8 items-end justify-center w-full max-w-5xl relative z-10">
                {/* Free Tier */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="w-full max-w-xs p-6 rounded-2xl bg-card border border-border opacity-70 scale-95"
                >
                    <h3 className="text-2xl font-bold text-muted-foreground mb-2">Free</h3>
                    <p className="text-sm text-muted-foreground mb-6">Core Insights</p>
                    <ul className="space-y-3 mb-8">
                        <li className="flex items-center gap-2 text-sm text-muted-foreground"><Check className="w-4 h-4" /> Basic Tracking</li>
                        <li className="flex items-center gap-2 text-sm text-muted-foreground"><Check className="w-4 h-4" /> Expense Categorization</li>
                    </ul>
                    <div className="w-full py-3 rounded-xl border border-border text-center text-muted-foreground">Forever Free</div>
                </motion.div>

                {/* Pro Tier - Highlighted */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="w-full max-sm p-8 rounded-2xl bg-gradient-to-b from-card to-background border border-primary shadow-[0_0_40px_rgba(0,255,0,0.1)] relative"
                >
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-black px-4 py-1 rounded-full text-xs font-bold uppercase">Most Popular</div>
                    <h3 className="text-4xl font-bold text-white mb-2">Pro</h3>
                    <p className="text-lg text-primary mb-6">₹999<span className="text-sm text-muted-foreground">/mo</span></p>
                    <ul className="space-y-4 mb-8">
                        <li className="flex items-center gap-3 text-base text-white"><Check className="w-5 h-5 text-primary" /> Advanced AI Suggestions</li>
                        <li className="flex items-center gap-3 text-base text-white"><Check className="w-5 h-5 text-primary" /> Goal Strategy Agents</li>
                        <li className="flex items-center gap-3 text-base text-white"><Check className="w-5 h-5 text-primary" /> Risk Optimization</li>
                    </ul>
                    <div className="w-full py-4 rounded-xl bg-primary text-black font-bold text-center hover:bg-primary/90 cursor-pointer shadow-lg shadow-primary/20">
                        Get Started
                    </div>
                </motion.div>

                {/* Future Layers */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    className="w-full max-w-xs p-6 rounded-2xl border border-dashed border-border/50 bg-transparent"
                >
                    <h3 className="text-xl font-bold text-muted-foreground mb-2">Future Layers</h3>
                    <div className="space-y-4 mt-6">
                        <div className="p-3 bg-card/50 rounded-lg border border-border/50 text-sm text-muted-foreground flex items-center gap-3">
                            <Lock className="w-4 h-4" /> Advisory Fees
                        </div>
                        <div className="p-3 bg-card/50 rounded-lg border border-border/50 text-sm text-muted-foreground flex items-center gap-3">
                            <Lock className="w-4 h-4" /> Execution Revenue
                        </div>
                        <div className="p-3 bg-card/50 rounded-lg border border-border/50 text-sm text-muted-foreground flex items-center gap-3">
                            <Lock className="w-4 h-4" /> Distribution Comm.
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Slide7GTM;